import { useQuery } from "@tanstack/react-query";
import { useAxios } from "../../../api/axios";
import { useTranslation } from "react-i18next";

export const useCheckoutCount = (Visible: boolean) => {
  const axios = useAxios();
  const { t } = useTranslation();

  return useQuery({
    queryKey: ["checkout-count", Visible],
    queryFn: async () => {
      try {
        const response = await axios.get(t("checkout-count"));
        return response?.data?.data;
      } catch (error) {
        console.error("Error fetching flipper vault data:", error);
        return;
      }
    }
  });
};
